import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ValidI18nMessage from 'ecosystem-marketplace-core/i18n/components/ValidI18nMessage';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import AssetStorefrontContainer from '../../common/containers/AssetStorefrontContainer';
import NotFoundError from '../../components/error/NotFoundError';
import { selectCollectionBySlug, selectCollectionsRequestState } from '../../slices/collections/collectionsSlice';
import { useFetchThemeCollectionOfferingIds } from '../hooks/useFetchThemeCollectionOfferingIds';
export default function ThemeCollectionContainer() {
  const {
    collection: slug
  } = useParams();
  const collection = useSelector(state => selectCollectionBySlug(state, slug));
  const collectionsRequestState = useSelector(selectCollectionsRequestState);
  const {
    fetchThemeCollectionOfferingIds
  } = useFetchThemeCollectionOfferingIds({
    collectionId: collection ? collection.id : undefined
  });
  const handleFetchCollectionOfferingIds = useCallback(() => fetchThemeCollectionOfferingIds(), [fetchThemeCollectionOfferingIds]);

  if (!isFulfilled(collectionsRequestState)) {
    return null;
  }

  if (!(collection && collection.publishedListing)) {
    return /*#__PURE__*/_jsx(NotFoundError, {});
  }

  return /*#__PURE__*/_jsx(AssetStorefrontContainer, {
    collectionId: collection.id,
    description: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: collection.publishedListing.description,
      message: `marketplace-assets-ui.collections.collection_${collection.id}.description`,
      messageComponent: FormattedHTMLMessage
    }),
    onFetchCollectionOfferingIds: handleFetchCollectionOfferingIds,
    title: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: collection.publishedListing.title,
      message: `marketplace-assets-ui.collections.collection_${collection.id}.title`
    })
  });
}